import { useMemo } from "react";
import truncate from "lodash/truncate";

interface UseTruncateOptions {
  mode?: "characters" | "words";
  affix?: string;
}
export const useTruncate = (
  phrase: string,
  length: number,
  options?: UseTruncateOptions,
) => {
  const opts: UseTruncateOptions = useMemo(
    () => ({
      mode: options?.mode ?? "words",
      affix: options?.affix ?? "...",
    }),
    [options],
  );

  return useMemo(
    () =>
      phrase.length <= length
        ? phrase
        : truncate(phrase, {
            length: length,
            separator: opts.mode === "words" ? /,?\.? +|\n+/ : "",
            omission: opts.affix,
          }),
    [length, opts.mode, opts.affix, phrase],
  );
};
